import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SignedInLinks from './SignedInLinks';
import SignedOutLinks from './SignedOutLinks';
import { scaleDown as Menu } from 'react-burger-menu'
import '../../css/NavigationBar.css'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Credit from './Credit'
import '../../style.scss';

import { connect } from 'react-redux';

class NavigationBar extends Component {
  state = {
    open: false
  }
  render() {

    const { auth } = this.props;
    const { activeTab } = this.props;
    const links = auth.uid ? <SignedInLinks uid={auth.uid} /> : <SignedOutLinks />;

    if(!activeTab) {
      document.body.style.backgroundImage = "url('https://miro.medium.com/max/1400/0*o6xpHUxgXlmH5D_w')";
      document.body.style.backgroundSize = "cover";
    } else {
      document.body.style.backgroundImage = "url('')";
      document.body.style.background = "#212121";
      document.body.style.backgroundSize = "cover";
    }

    return (
      <Menu pageWrapId={ "page-wrap" } outerContainerId={ "root" }>
        <div className="menuLogo">
          <Link to="/welcome">Building Block Trade</Link>
        </div>
        <Link className={(activeTab === 'dashboard') ? 'active' : ''} to="/dashboard">Dashboard</Link><br />
        <Link className={(activeTab === 'market') ? 'active' : ''} to="/market">Market</Link><br />
        <Link className={(activeTab === 'trading-book') ? 'active' : ''} to="/trading-book">Trading Book</Link><br />
        <Link className={(activeTab === 'admin') ? 'active' : ''} to="/admin">Admin Panel</Link>
        <div className="links">
          { links }
        </div>
        <div className="menuCredit" onClick={(e) => this.setState({open: !this.state.open})}>Created by DALI Lab</div>
        <Modal isOpen={this.state.open}>
          <ModalHeader>DALI Lab - Building Block Trade Team</ModalHeader>
          <ModalBody>
            <Credit name="Sonal Butala '22 - Project Manager" 
            image="https://ca.slack-edge.com/T02FQFVUX-UJW1WSF6U-b10433bafd8f-512" />
            <Credit name="Archita Harathi '22 - Designer" 
            image="https://www.nailseatowncouncil.gov.uk/wp-content/uploads/blank-profile-picture-973460_1280.jpg" />
            <Credit name="Cindy Shen '21 - Designer" 
            image="https://www.nailseatowncouncil.gov.uk/wp-content/uploads/blank-profile-picture-973460_1280.jpg" />
            <Credit name="Drew Schneider '21 - Designer" 
            image="https://ca.slack-edge.com/T02FQFVUX-UVDCVRRBQ-975a3f42253a-512" />
            <Credit name="Ian Hou '22 - Software Engineer" 
            image="https://www.nailseatowncouncil.gov.uk/wp-content/uploads/blank-profile-picture-973460_1280.jpg" />
            <Credit name="John McCambridge '22 - Software Engineer" 
            image="https://ca.slack-edge.com/T02FQFVUX-UGYRKSH0R-7553acba0005-512" />
          </ModalBody>
          <ModalFooter>
          <Button color="primary" onClick={ (e) => this.setState({open: !this.state.open}) }>Close</Button>{' '}
          </ModalFooter>
        </Modal>
      </Menu>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        theme: state.mode,
    };
};

export default connect(mapStateToProps)(NavigationBar);
